import { useCallback, useEffect, useState } from 'react';

export const useDeviceSize = () => {
  const [windowSize, setWindowSize] = useState<number | null>(null);

  const windowResizeHandler = useCallback(() => {
    setWindowSize(window.innerWidth);
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setWindowSize(window.innerWidth);
      window.addEventListener('resize', windowResizeHandler);

      return () => {
        window.removeEventListener('resize', windowResizeHandler);
      };
    }
  }, [windowResizeHandler]);

  return {
    windowSize,
    isMobile: windowSize !== null && windowSize <= 1024,
  };
};
